jQuery(document).ready(function($){
    $('.accordion-header').click(function(){
        var item = $(this).closest('.accordion-item');
        var content = item.find('.accordion-content');
        
        if(item.hasClass('active')){
            item.removeClass('active');
            content.slideUp();
        }else{
            $('.accordion-item').removeClass('active');
            $('.accordion-content').slideUp();

            item.addClass('active');
            content.slideDown();
        }        
    });

    //VIDEO PLAYER
    $('.video_thumbnail').click(function(e){
        e.stopPropagation();
        var video_wrapper = $(this).closest('.video_wrapper');
        var video = video_wrapper.find('video');
        video_wrapper.addClass('playing');
        if(video.length > 0) {
            video[0].play();
        }
    });

    $('video').click(function(e){
        e.stopPropagation();
    });

    $('.video_wrapper').click(function(){
        var video_wrapper = $(this);
        var video = video_wrapper.find('video');
        video_wrapper.removeClass('playing');
        if(video.length > 0) {
            video[0].pause();
        }
    });

    //featured_on_logos_carousel
    $('.featured_on_logos_carousel').slick({
        dots: false,
        infinite: true,
        speed: 5000,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        arrows: false,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    });
}); 